{
    "title": "Application Submitted",
    "subtitle": "We will contact you via email to confirm your application",
    "analysing": "Your application is currently being analyzed. You will be redirected shortly.",
    "closetab": "Or close this tab"
}